import { FrontEndColumn } from '@app/shared/interfaces/front-end-column';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  Observable,
  catchError,
  delay,
  retry,
  retryWhen,
  tap,
  throwError,
} from 'rxjs';
import { PageHeaderComponentModel } from '../interfaces/page-header-component-model';
import { environment } from 'src/environments/environment';
import { MenuModel } from '../interfaces/menu-model';
import { AppConfigService } from './app-config.service';
@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  constructor(private http: HttpClient) {}
  pageTitle = new BehaviorSubject('');
  pageTitle$ = this.pageTitle.asObservable();
  getPageHeaderComponent(
    model: string,
    page: string,
    tapCallback: (d: PageHeaderComponentModel) => void
  ) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('page', page);
    queryParams = queryParams.append('model', model);

    const request = this.http.get(
      `${AppConfigService.settings.apiUrl}Layout/PageHeaderComponentModel`,
      {
        params: queryParams,
      }
    );

    this.processRequest(request, tapCallback);
  }

  getMenu(menuId: string, tapCallback: (d: MenuModel[]) => void) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('menuId', menuId);

    const request = this.http
      .get(`${AppConfigService.settings.apiUrl}Layout/Menu`, {
        params: queryParams,
      })
      .pipe(
        tap((menus) => {
          if (Array.isArray(menus) && menus.length === 0) {
            window.location.reload();
          }
        }),
        delay(1000),
        retry(2),
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      );

    this.processRequest(request, tapCallback);
  }

  getFrontEndColumns(
    model: string,
    tapCallback: (d: FrontEndColumn[]) => void
  ) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('model', model);

    const request = this.http.get(
      `${AppConfigService.settings.apiUrl}Layout/FrontEndColumn`,
      {
        params: queryParams,
      }
    );

    this.processRequest(request, tapCallback);
  }

  translate(value: string): string {
    return value;
  }

  private processRequest(
    request: Observable<Object>,
    tapCallback: (d: any) => void
  ) {
    const subscription = request
      .pipe(
        tap((d: any) => {
          tapCallback(d);
          subscription.unsubscribe();
        })
      )
      .subscribe();
  }

  getDashboards() {
    return this.http.get(
      `${AppConfigService.settings.apiUrl}Dashboard/Dashboards`
    );
  }
}
